exports.components = {
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-kk-js": () => import("./../../../src/pages/kk.js" /* webpackChunkName: "component---src-pages-kk-js" */)
}

